import { ranking, siteMeta } from "@/mocks/gossipData";

const tagColor: Record<string, string> = {
  "娱乐八卦": "bg-accent-100 text-accent-800",
  "影视综艺": "bg-primary-100 text-primary-700",
  "人物话题": "bg-secondary-200 text-secondary-900",
  "社会热议": "bg-primary-100 text-primary-700",
};

function formatHeat(n: number) {
  return (n / 10000).toFixed(0) + " 万";
}

export default function Focus() {
  return (
    <section id="focus" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-primary-600">Focus Ranking</p>
            <h2 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-4xl">
              本周焦点热榜
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600">
              基于平台热度与近期动态综合排序，实时更新本期最受关注的焦点事件。
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            数据更新于 {siteMeta.updateTime}
          </div>
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-2">
          {ranking.map((item) => {
            const isTop = item.rank <= 3;
            return (
              <article
                key={item.rank}
                className={
                  "group flex items-center gap-4 rounded-lg p-4 ring-1 transition-colors " +
                  (isTop
                    ? "bg-background-100 ring-background-200 hover:bg-background-100"
                    : "bg-background-50 ring-background-200 hover:bg-background-100")
                }
              >
                <span
                  className={
                    "font-heading flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-xl font-black " +
                    (item.rank === 1
                      ? "bg-primary-500 text-background-50"
                      : item.rank === 2
                      ? "bg-accent-500 text-accent-950"
                      : item.rank === 3
                      ? "bg-secondary-500 text-background-50"
                      : "bg-background-200 text-foreground-600")
                  }
                >
                  {item.rank}
                </span>

                <div className="min-w-0 flex-1">
                  <span
                    className={
                      "inline-block whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium " +
                      (tagColor[item.cat] || "bg-background-200 text-foreground-700")
                    }
                  >
                    {item.cat}
                  </span>
                  <h3 className="mt-1.5 truncate text-sm font-semibold text-foreground-900 md:text-base">
                    {item.title}
                  </h3>
                  <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                    <span>{formatHeat(item.heat)}热度</span>
                    <i
                      className={
                        item.trend === "up"
                          ? "ri-arrow-up-line text-primary-500"
                          : item.trend === "down"
                          ? "ri-arrow-down-line text-foreground-400"
                          : "ri-subtract-line text-foreground-400"
                      }
                    ></i>
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}